import STITCH_TYPES from './stitchTypes';

// Component to render stitch symbol with RS/WS awareness
const StitchSymbol = ({ type, isRS, cellSize = 24, style }) => {
  const stitch = STITCH_TYPES[type];
  
  if (!stitch || !stitch.symbol) {
    return (
      <span style={{ fontSize: Math.max(8, cellSize * 0.3) }}>
        {type}
      </span>
    );
  }

  const symbol = stitch.symbol;
  const path = symbol.path || (isRS ? symbol.rs : symbol.ws);
  // Stretch the symbol to fill the cell(s)
  const width = cellSize * (stitch.width || 1);
  const height = cellSize;
  
  return (
    <svg 
      viewBox={symbol.viewBox || '0 0 20 20'} 
      width={width}
      height={height}
      preserveAspectRatio="none"
      style={{
        display: 'block',
        margin: 'auto',
        overflow: 'visible',
        ...style
      }}
    >
      <path 
        d={path}
        stroke={symbol.stroke || '#333333'}
        strokeWidth={symbol.strokeWidth || 1}
        fill={symbol.fill || 'none'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StitchSymbol;